import { GridFooterContainer, GridPagination, GridSelectedRowCount, useGridApiContext } from "@mui/x-data-grid";
import React from "react";

const CustomDataGridFooter = () => {
    const gridApi = useGridApiContext();
    return (
        <GridFooterContainer>
            <GridPagination />
            {
                !!gridApi.current.getSelectedRows().size &&
                <GridSelectedRowCount selectedRowCount={gridApi.current.getSelectedRows().size} />
            }
        </GridFooterContainer>
    );
};

export default CustomDataGridFooter;